module.exports = __webpack_public_path__ + "static/media/failed_order_delivery.c355d6f1.svg";